<template>
  <el-dialog
    title="工队询价"
    :visible.sync="isShowsDialog"
    :close-on-click-modal="false"
    :before-close="goList"
    :append-to-body="true"
    width="1000px"
  >
    <el-form
      key="form"
      :model="inquiryForm"
      :rules="ruleForm"
      ref="ruleForm"
      label-width="102px"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目名称" prop="name">
            <el-input
              maxlength="20"
              v-model="inquiryForm.name"
              placeholder="请输入询价项目名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目地址" prop="tempWorkTypeList">
            <el-cascader
              ref="tempAddressList"
              v-model="inquiryForm.tempWorkTypeList"
              :options="categoryList"
              :props="{ expandTrigger: 'hover', label: 'name', value: 'no' }"
              clearable
              placeholder="请选择项目地址"
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="人数要求" prop="personNum">
            <el-input
              maxlength="2"
              v-model="inquiryForm.personNum"
              placeholder="请输入人数要求"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="项目工期" prop="projectDuration">
            <div style="display: flex">
              <el-input class="flexSalary" placeholder="请输入项目工期" maxlength="3" v-model="inquiryForm.projectDuration"></el-input>
              <el-select
                v-model="inquiryForm.projectDurationUnit"
                class="salarySelect"
                :value="1"
              >
                <el-option
                  v-for="(item, i) in ['天', '月', '年']"
                  :key="i"
                  :label="item"
                  :value="i + 1"
                >
                </el-option>
              </el-select>
            </div>
            </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item  label="结算方式" prop="settlementMethod">
            <el-select  
                v-model="inquiryForm.settlementMethod" 
                placeholder="请选择结算方式"  
                style="width: 100%">
              <el-option key="settlementMethod-1" label="天" :value="1"></el-option>
              <el-option key="settlementMethod-2" label="月" :value="2"></el-option>
              <el-option key="settlementMethod-3" label="季度" :value="3"></el-option>
              <el-option key="settlementMethod-4" label="年" :value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="询价方">
            <el-input
              v-model="inquirer"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人" prop="contacts">
            <el-input
              v-model="inquiryForm.contacts"
              maxlength="10"
              placeholder="请输入联系人"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="contactsTel">
            <el-input
              maxlength="11"
              v-model="inquiryForm.contactsTel"
              placeholder="请输入联系电话"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="询问的工队">
            <el-input
              v-model="detailNo.teamName"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="需求描述" prop="requirement">
            <el-input
              class="requirement"
              v-model="inquiryForm.requirement"
              maxlength="300"
              type="textarea"
              resize="none"
              rows="4"
              placeholder="请填写详细的报价描述
例：本工队拥有多年的XXXX经验，拥有多项专业资质工队成员能力优秀，都是从业多年的专业人员，本次报价方案为XX+XX计算，如有合作意愿，欢迎来电协商。"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="text-align: center;margin-top:67px">
        <el-button
          class="cancal-btn"
          @click="goList"
          style="color: #969696; padding: 9px 14px"
          >取消</el-button
        >
        <el-button
          @click="save()"
          class="add-btn"
          :disabled="disabled"
          style="margin-left: 15px; padding: 9px 14px"
          >立即询价</el-button
        >
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { apiResignAll } from "@/api/apiResignAll"
import { mapState } from "vuex"
import {validator} from "@/utils/validator";
import localStorage from "@/storage/localStorage"
export default {
  name: "subscribeEdit",
  props: {
    isShowsDialog: {
      type: Boolean,
      default: false
    },
    detailNo: {
      type: Object,
      default() {
        return {}
      }
    },
    inquirer: {
      type: String,
      default() {
        return ''
      }
    }
  },
  components: {},
  data() {
    return {
      disabled: false,
      categoryList: [],
      inquiryForm: {
        name: "",
        tempWorkTypeList: [],
        personNum:'',
        projectDuration: '',
        projectDurationUnit: 1,
        settlementMethod:'',
        contacts: "",
        contactsTel: "",
        requirement: "",
      },
      ruleForm: {
        name: [{ required: true, trigger: "blur", message: "请输入项目名称" },{
            pattern: /^([\u4e00-\u9fa5·])+\·{0,1}$/,
            trigger: "blur",
            message: "请输入正确的项目名称",
          }
        ],
        tempWorkTypeList: [{ required: true, trigger: "change", message: "请选择项目地址" }],
        personNum: [{required: true, trigger: "blur",
            validator: (rule, value, callback) => {
              if(!value&&value!==0){
                callback(new Error('请输入人数要求'));
              }
              else if(value==0||isNaN(value)||value.indexOf('-')!==-1||value.indexOf('+')!==-1||value.charAt(0).indexOf('0')!==-1){
                callback(new Error('请输入1-99的数字'));
              }else {
                callback();
              }
            }
          },
        ],
        projectDuration: [{ required: true, trigger: "blur", 
         validator: (rule, value, callback) => {
              if(!value&&value!==0){
                callback(new Error('请输入项目工期'));
              }else if(value==0||isNaN(value)||value.indexOf('-')!==-1||value.indexOf('+')!==-1||value.charAt(0).indexOf('0')!==-1){
                callback(new Error('请输入1-999的数字'));
              }else{
                callback();
              }
            }
          }
        ],
        settlementMethod: [{ required: true, trigger: "change", message: "请选择结算方式" }],
        contacts: [{ required: true, trigger: "blur", message: "请输入联系人"},
        {
            pattern: /^([\u4e00-\u9fa5·])+([\u4e00-\u9fa5·])+\·{0,2}$/,
            trigger: "blur",
            message: "请输入正确的联系人",
          }
        ],
        contactsTel: [{ required: true, trigger: "blur", validator: validator.checkPhone }],
        requirement: [{ required: true, trigger: "blur", message: "请输入需求描述" }],
      }
    }
  },
  computed: {
    ...mapState({
      userNo: state => state.user.no,
      companyNo: state => state.user.companyNo,
      teamNo: state => state.user.teamNo,
      companyName: state => state.user.companyName,
      teamName: state => state.user.teamName,
      name: state => state.user.realName,
    })
  },
  watch: {
    isShowsDialog: {
      async handler(v) {
        if (!v) return
        this.disabled = false
        //新增
        let no=JSON.parse(localStorage.read("inquiryTeamNo"))
        let inquiryData = JSON.parse(localStorage.read("inquiryData"))
        let inquiryUserNo = JSON.parse(localStorage.read("inquiryUserNo"))
        if(no==this.detailNo.no&&inquiryUserNo===this.userNo){
          this.inquiryForm=inquiryData
        }else{
          this.inquiryForm={
            name: "",
            tempWorkTypeList: [],
            personNum:'',
            projectDuration: '',
            projectDurationUnit: 1,
            settlementMethod:'',
            contacts: "",
            contactsTel: "",
            requirement: "",
          }
        }
      },
      immediate: true //true 深度监听
    },
  },
  mounted() {
    this.getDomicile()
  },
  methods: {
    //获取工种
    async getDomicile() {
      let res = await apiResignAll.getLocation()
      this.categoryList = res.data.data.data
    },  
    //取消按钮
    goList() {
      if(this.inquiryForm.name||this.inquiryForm.tempWorkTypeList.length||this.inquiryForm.personNum||this.inquiryForm.projectDuration
      ||this.inquiryForm.settlementMethod||this.inquiryForm.contacts||this.inquiryForm.contactsTel||this.inquiryForm.requirement){
        localStorage.set("inquiryData", JSON.stringify(this.inquiryForm))
        localStorage.set("inquiryTeamNo", JSON.stringify(this.detailNo.no))
        localStorage.set("inquiryUserNo", JSON.stringify(this.userNo))
      }
      this.$emit("update:isShowsDialog", false)
    },
    //确定按钮
    save() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          this.disabled = true
          //处理项目地址 
          this.inquiryForm.provinceNo =this.inquiryForm.tempWorkTypeList[0];
          this.inquiryForm.cityNo = this.inquiryForm.tempWorkTypeList[1];
          this.inquiryForm.areaNo = this.inquiryForm.tempWorkTypeList[2];
          let addName = this.$refs.tempAddressList.inputValue;
          addName = addName.replaceAll(" ", "");
          addName = addName.split("/");
          this.inquiryForm.provinceName = addName[0];
          this.inquiryForm.cityName = addName[1];
          this.inquiryForm.areaName = addName[2];
          //处理被询价的 
          this.inquiryForm.markPriceType =this.detailNo.companyNo?2:this.detailNo.teamNo?3:1;
          if(this.detailNo.companyNo){
            this.inquiryForm.markCompanyNo =this.detailNo.companyNo;
          }
          if(this.detailNo.teamNo){
            this.inquiryForm.markTeamRoleNo =this.detailNo.teamNo;
          }
          this.inquiryForm.markUserNo=this.detailNo.userNo
          this.inquiryForm.teamNo=this.detailNo.no
          let resdata = await apiResignAll.addQueryPrice(this.inquiryForm)
          if (resdata.data.code == 200) {
            this.$emit("update:isShowsDialog", false)
            this.$refs.ruleForm.clearValidate();
            this.$message.showPermissionTips('询价成功',() => {},false,'知道了',true)
          } else {
            this.$message.error(resdata.data.msg)
            this.$emit("update:isShowsDialog", false)
            this.disabled = false
          }
        }
      })
    }
  }
}
</script>

<style lang="scss"  scoped>
.cancal-btn:hover {
  border-color: #0286df;
  background: #fff;
  color: #0286df !important;
}
.add-btn{
  border-color: #0286df;
  background: #0286df;
  color: #fff !important;
  &:hover,&:focus{
  border-color: #0286df;
  background: #0286df;
  color: #fff !important;
  }
}
/deep/.flexSalary {
  width: 330px;
  border-radius: 4px 0 0 4px;
  .el-input__inner {
    border-right: none;
    border-radius: 4px 0 0 4px;
  }
}
/deep/.salarySelect {
  width: 50px;
  background: #f5f7fa;
  .el-input__inner {
    border-radius: 0 4px 4px 0;
    background: #f5f7fa;
    color: #666;
    padding-right: 19px;
  }
  .el-input__icon {
    width: 19px;
  }
}
/deep/.el-input__inner {
  padding-left: 10px;
  height: 34px;
  line-height: 34px;
  color: #000;
}
/deep/.el-form-item {
  height: 34px;
  line-height: 34px;
  margin-bottom: 15px;
}
/deep/.el-form-item__content {
  line-height: 34px;
  width: 380px;
}
/deep/.el-cascader {
  line-height: 34px;
  width: 380px;
}
/deep/.el-form-item__label {
  line-height: 34px;
  color: #333;
}
/deep/.el-dialog__body {
  padding: 15px 5px 20px 0px;
  border-top:1px solid #DFE4EA;
}
/deep/.el-dialog__title {
  line-height: 42px;
  color: #000;
}
/deep/.el-dialog__headerbtn {
  top: 0px;
  line-height: 42px;
}
/deep/.el-dialog__header {
  padding: 0 20px !important;
  height: 42px;
}
/* 错误提示文本 */
/deep/.el-form-item__error {
  padding-top: 1px;
}
/deep/.el-input__inner {
  color: #000;
  border: 1px solid #e4e7ed;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-left: 10px;
}
/deep/.el-textarea__inner {
  color: #000;
  padding-left:10px;
}
/deep/.el-input-group__append {
  padding: 0 9px;
  color: #666666;
}
.el-form-item {
  margin-bottom: 15px;
}
.requirement{
  width: 878px;
}
</style>